import { createFileRoute } from '@tanstack/react-router'

import { PageLayout } from '@/components/layout'

import { ProductForm } from '@/features/product/components/product-form'

export const Route = createFileRoute('/_app/product/create')({
  loader: () => ({
    crumb: 'Tambah Produk',
  }),
  component: Component,
})

function Component() {
  const navigate = Route.useNavigate()

  return (
    <PageLayout>
      <ProductForm mode='create' onBack={() => navigate({ to: '/product', replace: true })} />
    </PageLayout>
  )
}
